import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { } from '@angular/http';
import { BhtpComponentModule } from '@bhtp-client-web/component';

import { Ng2Bs3ModalModule } from '@bhtp-fork/ng2-bs3-modal/ng2-bs3-modal';
import { SharedModule } from './../shared/shared.module';
import { EmailQuoteModal } from './email-quote-modal.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        Ng2Bs3ModalModule,
        SharedModule,
        BhtpComponentModule
    ],
    declarations: [
        EmailQuoteModal
    ],
    exports: [
        EmailQuoteModal
    ],
    providers: []
})
export class EmailQuoteModule { }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/email-quote/email-quote.module.ts